import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { SpotlightItemType } from './spotlight.types';
export const QUICK_LINKS = [
    {
        id: 'quick-admin-settings',
        label: 'Admin settings',
        description: 'Manage system settings',
        icon: IconID.COG,
        type: SpotlightItemType.NAVIGATION,
        path: '/admin',
        keywords: ['admin', 'settings', 'configuration'],
    },
    {
        id: 'quick-profile-settings',
        label: 'Profile settings',
        description: 'Manage your profile',
        icon: IconID.COG,
        type: SpotlightItemType.NAVIGATION,
        path: '/profile',
        keywords: ['profile', 'settings', 'account'],
    },
    {
        id: 'quick-community',
        label: 'Community',
        description: 'Visit ThoughtSpot Community',
        icon: IconID.INFORMATION_CIRCLE,
        type: SpotlightItemType.NAVIGATION,
        action: () => window.open('https://community.thoughtspot.com', '_blank'),
        keywords: ['community', 'help', 'forum'],
    },
    {
        id: 'quick-developer-docs',
        label: 'Developer Docs',
        description: 'View developer documentation',
        icon: IconID.INFORMATION_CIRCLE,
        type: SpotlightItemType.NAVIGATION,
        action: () => window.open('https://developers.thoughtspot.com', '_blank'),
        keywords: ['developer', 'docs', 'documentation', 'api'],
    },
    {
        id: 'quick-muze-charts-docs',
        label: 'Muze Charts Docs',
        description: 'View chart documentation',
        icon: IconID.INFORMATION_CIRCLE,
        type: SpotlightItemType.NAVIGATION,
        action: () => window.open('https://www.charts.thoughtspot.com/', '_blank'),
        keywords: ['muze', 'charts', 'docs', 'documentation'],
    },
];
export const getCreateActionItems = (routePaths) => [
    {
        id: 'action-create-spotter',
        label: 'Create Spotter chat',
        description: 'Start AI-powered conversation',
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.ACTION,
        path: routePaths.ConvAssist,
        keywords: ['new', 'create', 'spotter', 'ai', 'chat', 'conversation'],
    },
    {
        id: 'action-create-liveboard',
        label: 'Create Liveboard',
        description: 'Create a new liveboard dashboard',
        icon: IconID.LIVEBOARD_V2,
        type: SpotlightItemType.ACTION,
        path: routePaths.Pinboards,
        keywords: ['new', 'create', 'liveboard', 'dashboard', 'pinboard'],
    },
    {
        id: 'action-create-connection',
        label: 'Create Connection',
        description: 'Connect to a data source',
        icon: IconID.CONNECTOR_WHITE,
        type: SpotlightItemType.ACTION,
        path: routePaths.Embrace,
        keywords: ['new', 'create', 'connection', 'data source', 'database'],
    },
    {
        id: 'action-create-collection',
        label: 'Create Collection',
        description: 'Organize content in a collection',
        icon: IconID.COLLECTION,
        type: SpotlightItemType.ACTION,
        path: routePaths.Home,
        keywords: ['new', 'create', 'collection', 'folder', 'organize'],
    },
];
export const CREATE_ACTION_LABELS = [
    'Create Spotter chat',
    'Create Answer',
    'Create Liveboard',
    'Create Connection',
    'Create Collection',
];
export const TYPE_LABEL_CONFIG = {
    answer: {
        keywords: ['answer'],
        label: 'Answer',
    },
    answerInLiveboard: {
        keywords: ['answer', 'liveboard', 'lb'],
        label: 'Answer (in a LB)',
    },
    liveboard: {
        keywords: ['liveboard'],
        label: 'Liveboard',
    },
    model: {
        keywords: ['model'],
        label: 'Model',
    },
    adminSettings: {
        keywords: ['admin', 'settings'],
        label: 'Admin Settings',
    },
    help: {
        keywords: ['help', 'docs', 'documentation', 'community'],
        label: 'Help',
    },
};
export const DEFAULT_TYPE_LABELS = {
    navigation: 'Navigate',
    action: 'Action',
};
export const RECENT_CONFIG = {
    maxItems: 10,
    displayCount: 6,
};
export const KEYBOARD_SHORTCUTS = {
    navigate: '↑ ↓',
    openNewTab: 'Shift + ↵',
    openInSpotter: '⌘ + ↵',
    open: '↵',
};
//# sourceMappingURL=spotlight-config.js.map